export enum Api {
    Incontrol,
    IncontrolV2
}
